module.exports = __webpack_public_path__ + "static/media/goforward.9963320b.svg";